// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "footer{width:100%;height:60px;padding:20px 0;background-color:#f5f5f5}", "",{"version":3,"sources":["webpack://./src/app/components/footer/footer.scss"],"names":[],"mappings":"AAAA,OACE,UAAA,CACA,WAAA,CACA,cAAA,CACA,wBAAA","sourcesContent":["footer {\n  width: 100%;\n  height: 60px;\n  padding: 20px 0;\n  background-color: #f5f5f5;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
